// 枚举查询。传入数组和值
// returnLabel是返回的字段名
export function getEnumeration (val, Arr, returnLabel = 'label', returnValue = 'value') {
  let label
  Arr.forEach(item => {
    if (item[returnValue] === val) {
      label = item[returnLabel]
    }
	})
  return label
}
